export default __webpack_public_path__ + "static/media/Earnings-Call-Audio-Recording-Q4-FY26.42fbacf5.mp3";